import React from "react";
import { Route } from "react-router-dom";
import { HomePage } from "./";

export const routes = [
  <Route exact path="/home" component={HomePage} />
];
